import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import MyContainer from "../../../MyContainer";
import { useCategoriesSectionStyles } from "./CategoriesSection.styles";
import { useI18n } from "../../../../i8n/useI18n";
import { useCommerceData } from "../../../../hooks/useCommerceData";
import { commerceRepository } from "../../../../api";
import Reveal from "../../../ui/Reveal";
import SectionEyebrow from "../../../ui/SectionEyebrow";

const CategoriesSection = () => {
    const { classes } = useCategoriesSectionStyles();
    const { t } = useI18n();
    const { data: collections } = useCommerceData(() => commerceRepository.getCollections(), []);

    const categories: { slug: string; title: string; description: string; cta: string }[] = t("home.categoriesSection.categories");

    return (
        <MyContainer>
            <Reveal>
                <Box className={classes.header}>
                    <SectionEyebrow label={t("home.categoriesSection.overline")} />
                    <Typography variant="h2" sx={{ mt: 2 }}>{t("home.categoriesSection.title")}</Typography>
                    <Typography variant="body1" className={classes.description}>
                        {t("home.categoriesSection.description")}
                    </Typography>
                </Box>
            </Reveal>

            <Box className={classes.grid}>
                {categories.map((category, index) => {
                    const collection = collections?.find((c) => c.handle === category.slug);
                    return (
                        <Reveal key={category.slug} delay={index * 0.05}>
                            <Box component={RouterLink} to={`/shop/${category.slug}`} className={classes.card}>
                                {collection?.image && (
                                    <Box component="img" src={collection.image.url} alt={category.title} className={classes.image} />
                                )}
                                <Box className={classes.overlay} />
                                <Box className={classes.cardContent}>
                                    <Typography variant="h3" className={classes.cardTitle}>{category.title}</Typography>
                                    <Typography variant="body2" className={classes.cardDescription}>{category.description}</Typography>
                                    <Button variant="outlined" size="small" sx={{ color: "common.white", borderColor: "common.white" }}>
                                        {category.cta}
                                    </Button>
                                </Box>
                            </Box>
                        </Reveal>
                    );
                })}
            </Box>
        </MyContainer>
    );
};

export default CategoriesSection;
